import { render, staticRenderFns } from "./TableSigleImg.vue?vue&type=template&id=356db7d3&scoped=true"
import script from "./TableSigleImg.vue?vue&type=script&lang=js"
export * from "./TableSigleImg.vue?vue&type=script&lang=js"
import style0 from "./TableSigleImg.vue?vue&type=style&index=0&id=356db7d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356db7d3",
  null
  
)

export default component.exports